// Это щётко по факту валидация! По Тамаеву - честная игра! 🎲
import { z } from 'zod';
export const TelegramInitDataSchema = z.object({
    user: z.object({
        id: z.number(),
        is_bot: z.boolean().optional(),
        first_name: z.string(),
        last_name: z.string().optional(),
        username: z.string().optional(),
        language_code: z.string().optional(),
        is_premium: z.boolean().optional(),
    }),
    auth_date: z.number(),
    hash: z.string(),
});
export const JwtPayloadSchema = z.object({
    sub: z.number(), // user id
    telegramId: z.number(),
    iat: z.number(),
    exp: z.number(),
});
export const AuthResponseSchema = z.object({
    accessToken: z.string(),
    user: z.object({
        id: z.number(),
        telegramId: z.number(),
        username: z.string().optional(),
        tonAddress: z.string().optional(),
    }),
});
//# sourceMappingURL=auth.js.map